import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import BackgroundImage from '../../assets/2021calendar.png';
import taglineLogo from '../../assets/createAccountPage/nn_taglinelogo_hd-7261aedcdab6423445387624801ca3e6.png';


import './CalendarPage.css';


function CalendarPage(props) {
  const { image, title, noPhoto } = props;

  useEffect(() => {
    if (document.getElementById('navigation')) {
      document.getElementById('navigation').style.display = 'none';
    }
    if (document.getElementsByClassName('footer').length) {
      document.getElementsByClassName('footer')[0].style.display = 'none';
    }

    return () => {
      if (document.getElementById('navigation')) {
        document.getElementById('navigation').style = '';
      }
      if (document.getElementsByClassName('footer').length) {
        document.getElementsByClassName('footer')[0].style = '';
      }
    };
  });

  return (
    <>
      <div id="navigation2">
        <nav
          className="navbar navbar-lg navbar-topnav navbar-static-top"
          id="header-nav"
          role="navigation"
        >
          <div className="container calendar-container">
            <span className="navbar-brand calendar-logo">
              <a href="/">
                <img
                  alt="Naked News: The Program With Nothing To Hide"
                  src={taglineLogo}
                />
              </a>
            </span>
            <span className="pull-right visible-lg">
              <h4>{title}</h4>
            </span>
          </div>
        </nav>
      </div>
      <div id="purchaseIndexView">
        <div id="purchaseIndexView">
          <div className="content">
            <div className="container">
              {!noPhoto && (
                <div className="col-md-6 col-sm-12 col-xs-12 calendar-image-container accounts-right-image" style={{ textAlign: 'right' }}>
                  <img alt="" className="claendar-image" src={image} />
                </div>
              )}
              <div className={`${noPhoto ? 'col-md-12' : 'col-md-6'} col-sm-12 col-xs-12`}>
                {props.children}
              </div>
            </div>
          </div>
        </div>
        <div
          className="footer2" style={{
            backgroundColor: '#000',
            paddingTop: '20px',
          }}
        >
          <div className="container">
            <p
              className="text-center" style={{
                fontSize: '12px',
                color: '#fff',
              }}
            >
              Copyright © 1999-2019 Naked Broadcasting Network
              Inc. All Rights Reserved.
              <a href="/terms_of_service" style={{ color: '#fff' }}>Terms of Use</a>
              <br />
              "Naked News" is a registered trademark of Egalaxy
              Multimedia Inc.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

CalendarPage.propTypes = {
  children: PropTypes.object,
  image: PropTypes.string,
  noPhoto: PropTypes.bool,
  title: PropTypes.string,
};

CalendarPage.defaultProps = {
  title: '2021 Calendar is finally here. Order now!',
  image: BackgroundImage,
  noPhoto: false,
};

export default CalendarPage;
